import { setLocalePath } from "@/locales/index";
export const locale_file_path = "views.list_control.";
/**
 * 언어팩 경로 셋팅 메서드
 * @param appendPath 추가로 붙일 경로 문자열
 * @returns
 */
export const initAutoLc = (appendPath = "") => setLocalePath(locale_file_path + appendPath);
export default {
    page_title: "목록관제",
    header_controller: {
        card_count: "신용카드 완료",
        open_map_control: "지도관제 열기",
        reset_sort: "정렬 초기화",
    },
    contextmenu: {
        order_info: "주문 상세보기",
        worker_info: "라이더 상세보기",
        allocate: "배차하기",
    },
    sub_controller: {
        order_agency: "주소기반",
        hub_type: "발주유형",
        pay_type: "결제방법",
        reset: "@:common.reset",
        start: "작동중",
        stop: "일시정지",
    },
    thead: {
        state: "상태",
        allocated_worker: "담당 라이더",
        drop_address: "도착지 주소",
        caution: "주의사항",
        pickup_expected_at: "픽업 예상시간",
        pickup_address: "출발지 주소",
        pickup_memo: "출발지 메모",
        delivery_amount: "@:common.delivery_charge",
        promotion_charge: "프로모션 지원금",
        pay_type: "결제방법",
        goods_amount: "상품 금액",
        distance: "운행거리",
    },
};
